export class CartographyResourceInfos {
  public idResource: string;

  constructor(id: string) {
    this.idResource = id;
  }
}
